<div class="p-grid workStyle">
  <div class="p-col-12 p-md-8">
    <div class="p-grid">
      <div class="p-col-12 p-md-8 header">
        Quote [<span class="link" (click)="navigate()">{{quote.quoteNumber}}</span>] <span style="font-weight: normal;">{{quote.address.street}}, {{quote.address.city}}, {{quote.address.state.abbreviation}} {{quote.address.zip}}</span>
      </div>
      <div class="p-col-12 p-md-4" style="font-weight: bold;">
        Quote Created: {{quote.createdDate | date: 'shortDate'}}
        @if (current) {
          <div>
            Quote Expires: {{getExpireDate() | date: 'shortDate'}}
          </div>
        }
        @if (!current && quote.signedDate) {
          <div style="color: green">
            Quote Signed: {{quote.signedDate | date: 'shortDate'}}
          </div>
        }
        @if (!current && quote.rejectedDate) {
          <div style="color: red">
            Quote Declined: {{quote.rejectedDate | date: 'shortDate'}}
          </div>
        }
        @if (!current && quote.completionStatus === completionStatus.Quote_Expired) {
          <div style="color: red">
            Quote Expired: {{getExpireDate() | date: 'shortDate'}}
          </div>
        }
      </div>
    </div>
    @for (task of tasks; track task) {
      <div class="p-grid hide-sm">
        <div class="p-col-5">
          {{task.name}}: {{getTreeList(task)}}, {{task.location}}
        </div>
        <div class="p-col-3" style="text-align: right;">
          @if ((canSeeHiddenPrice || !quote.hidePrice) && task.fixedPrice) {
            <span>
              {{task.price | currency}}
            </span>
          }
          @if ((canSeeHiddenPrice || !quote.hidePrice) && !task.fixedPrice) {
            <span>
              @if (task.hourlyRate) {
                <span>{{task.hourlyRate | currency}} per hour</span>
              }
              <div class="fine-print" style="text-align: right; width: 100%">
                @if (task.minPrice || task.maxPrice) {
                  <span>Please note there will be a </span>
                }
                @if (task.minPrice) {
                  <span>minimum charge of {{task.minPrice | currency}}</span>
                }
                @if (task.minPrice && task.maxPrice) {
                  <span> and a </span>
                }
                @if (task.maxPrice) {
                  <span>maximum charge of {{task.maxPrice | currency}}</span>
                }
              </div>
            </span>
          }
        </div>
        <div class="p-col-4">
          {{getTaskStatusDisplay(task)}}
        </div>
      </div>
    }
  </div>
  <div class="p-col-12 p-md-4" style="text-align: right;">
    <p-button type="button" [label]="buttonText" (click)="navigate()" ></p-button>
  </div>
</div>